import { Request } from '../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../httpClient/serverApi/types/IGetItemsResult';

export interface ExploreContentParams extends IGetItemsParams {
}

export interface ExploreFavoriteContentForUserResult extends IGetItemsResult {
  content: any[];
}

export class ExploreFavoriteContentForUserRequest extends Request<ExploreContentParams, ExploreFavoriteContentForUserResult> {
  constructor(params: ExploreContentParams) {
    super('exploreFavoriteContentForUser', params);
  }
}
